import React, { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Tabs,
  Tab,
  Typography,
  Box,
  Tooltip,
  IconButton,
  Select,
  MenuItem,
  Badge,
  FormControl,
  Button,
} from "@material-ui/core";
import axios from "axios";

import ReportingModeCartHandle from "../ReportingModeCart/index.jsx";
import ReportingModePGScenarioListing from "./components/listings.jsx";
import { NoteAdd as NoteAddIcon } from "@material-ui/icons";
import PublishIcon from "@material-ui/icons/Publish";
import InsertModel from "./components/insertModel.jsx";
import { Link } from "react-router-dom";
import Modal from "../../cm_shared/cm_global_modal/index.jsx";
import ExecutionListingOfOpenLoop from "./../ExecutionListing/index.jsx";
import { LoadingContext } from "../../../../context/spinnerContext.jsx";
import HelperComponent from "../../cm_shared/Reporting/CustomHelper/index";
import HelpIcon from "@material-ui/icons/Help";
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function OpenLooReportingMode() {
  const { setIsLoading } = useContext(LoadingContext);
  const query = new URLSearchParams(window.location.search);
  const [fctwVal, setFctwVal] = useState(false);
  const type = query.get("open-loop-type");
  const [currentFilters, setCurrentFilters] = useState([]);
  const [region, setRegion] = useState("EUR");
  const [tabs, setTabs] = useState([
    {
      key: "listing",
      Value: "Listing",
    },
    {
      key: "topology",
      Value: "Topology",
    },
  ]);
  const [tabValue, setTabValue] = useState(0);
  const [selectValue, setSelectValue] = useState("");
  const [statusVal, setStatusVal] = useState("approved");
  const [modelVal, setModalval] = useState("");
  const [modelOptions, setModelOptions] = useState([]);
  const [modalContent, setModalContent] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [modalSize, setModalSize] = useState(false);
  const handleTabChange = async (event, newValue) => {
    console.log("newValue", newValue);
    setTabValue(newValue);
    setStatusVal('approved');
  };

  const handleSelectAll = async () => {
    try {
      setIsLoading(true);
      const searchOpts = JSON.parse(JSON.stringify(currentFilters));
      searchOpts[0].quality_check_status = [statusVal];
      const payload = {
        searchOptions: JSON.stringify(searchOpts),
        ...(type === "pg" && { fctw: fctwVal }),
        // ...(type === "pr" && { region: region }),
      };
      const response = await axios.post(
        type === "pg"
          ? "/cm/reporting-mode/select-all-pg-reporting"
          : "/cm/reporting-mode/pr-select-all-reporting",
        payload
      );
      if (response.data.data.length > 0) setCartItems(response.data.data);
    } catch (err) {
      console.error("err", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectChange = (event) => {
    const val = modelOptions.filter((item) => item._id === event.target.value);
    setModalval(val[0].value);
    const newSelectValue = event.target.value;
    const newSearchOptions = [{ model_record: [newSelectValue] }];
    setCurrentFilters(newSearchOptions);
    setSelectValue(newSelectValue);
    setCartItems([]);
  };

  const handleModal = (content, sizeVal = false) => {
    setModalContent(content);
    sizeVal && setModalSize(true);
    setIsOpen(true);
  };

  const handleModalClose = (cadCreated = false) => {
    setIsOpen(false);
    setModalSize(false);
    if (cadCreated) {
      setCartItems([]);
      setTabValue(1);
    }
  };

  const handleAddToCart = (row, fromPR = false) => {
    console.log("add to cart", row);
    if (fromPR) setCartItems(row);
    else setCartItems((prevCart) => [...prevCart, row]);
  };

  const onSubmitInsertModel = (inserValues) => {
    console.log("insertValues", inserValues);
    setIsOpen(false);
    setModalSize(false);
  };

  const handleRemoveFromCart = (row) => {
    console.log("remove from cart", row);
    setCartItems((prevCart) =>
      prevCart.filter((item) => item.scenario_uuid !== row.scenario_uuid)
    );
  };

  const getModelOptions = async () => {
    // const response = await axios.post(
    //   type === "pg" ? "yet_to_be_decided" : "yet_to_be_decided"
    // );
    // console.log("response", response);
    // setModelOptions(response.data.data);
    try {
      setIsLoading(true);
      const response = await axios.post(
        "/cm/close_loop/fetch-carmaker_model_record_V2",
        {
          page:"reporting_mode"
        }
      );
      setModelOptions(response.data);
      if (response.data.length > 0) {
        const defaultSelectValue = response.data[1]._id;
        setCurrentFilters([{ model_record: [defaultSelectValue] }]);
        setSelectValue(defaultSelectValue);
        setModalval(response.data[1].value);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getModelOptions();
  }, []);

  return (
    <div
      style={{
        padding: "0.6rem",
        position: "relative",
        background: "white",
        margin: "10px",
        borderRadius: "10px",
        height: "calc(100% - 120px)",
      }}
    >
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        content={modalContent}
        size={modalSize ? "sm" : "lg"}
        heightVal={modalSize ? "320px" : "500px"}
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "white",
          padding: "5px",
          width: "100%",
        }}
      >
        <Typography variant="h5">
          <Link to="/welcome">Open Loop </Link>
          {">"} {type === 'pg' ? 'PG' : 'PR'} {">"} Base Scenario Collection {">"} Reporting Mode
        </Typography>
        {
          <div style={{ margin: "-0.5rem 0 1rem 0" }}>
            <FormControl
              variant="outlined"
              style={{ minWidth: "140px", margin: "5px 1rem" }}
            >
              <Select
                value={selectValue}
                onChange={handleSelectChange}
                MenuProps={{
                  getContentAnchorEl: null,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                }}
                style={{ height: "40px" }}
              >
                {modelOptions.map((option) => {
                  if (option.key !== "Generic") {
                    return (
                      <MenuItem key={option._id} value={option._id}>
                        {option.value}
                      </MenuItem>
                    );
                  }
                })}
              </Select>
            </FormControl>
            {tabValue == 0 && (
              <Button
                onClick={handleSelectAll}
                variant="contained"
                style={{
                  backgroundColor: statusVal !== "bad" && "#622AD8",
                  color: "#ffffff",
                }}
                disabled={statusVal === "bad"}
              >
                Select All
              </Button>
            )}
            {tabValue === 0 && (
              <Tooltip placement="top" title={<h6>Bulk Upload</h6>}>
                <IconButton style={{ display: "none" }}>
                  <PublishIcon />
                </IconButton>
              </Tooltip>
            )}
            {tabValue === 0 && (
              <Tooltip placement="top" title={<h6>Handle Cart</h6>}>
                <IconButton
                  color="inherit"
                  onClick={() =>
                    handleModal(
                      <ReportingModeCartHandle
                        type={type}
                        cartItems={cartItems}
                        selectValue={modelVal}
                        fctw={fctwVal}
                        clearCart={() => {
                          setCartItems([]);
                          handleModalClose();
                        }}
                        handleClose={handleModalClose}
                      />
                    )
                  }
                >
                  <Badge
                    badgeContent={cartItems.length}
                    max={5000}
                    color="secondary"
                  >
                    <NoteAddIcon />
                  </Badge>
                </IconButton>
              </Tooltip>
            )}

            <Tooltip placement="top" title={<h6>Help</h6>}>
              <IconButton
                color="inherit"
                onClick={() =>
                  handleModal(
                    <HelperComponent
                      closeHandler={setIsOpen}
                      contentController={[
                        {
                          value: "tutorialVideo",
                          label: "Tutorial",
                          tutorials: [
                            {
                              videoURL: type && type.toUpperCase()==="PR"?"/video/PRReportingMode.mp4":"/video/openloopreportingMode.mp4",
                              text: `In this tutorial, we will have a walkthrough on how to use the open loop ${type && type.toUpperCase()} for Reporting mode.`,
                              title:
                                `Open loop | Base Scenario | Reporting mode | ${type && type.toUpperCase()}`,
                            },
                          ],
                        },
                      ]}
                      defaultSelector="tutorialVideo"
                    />
                  )
                }
              >
                <Badge max={5000} color="secondary">
                  <HelpIcon />
                </Badge>
              </IconButton>
            </Tooltip>
          </div>
        }
      </div>
      <AppBar position="static">
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="open loop reporting tabs"
        >
          {tabs.map((tab, index) => (
            <Tab label={tab.key} {...a11yProps(0)} />
          ))}
        </Tabs>
      </AppBar>
      <TabPanel value={tabValue} index={0}>
        <ReportingModePGScenarioListing
          cartItems={cartItems}
          type={type}
          selectValue={selectValue}
          searchOpts={currentFilters}
          onChangeFctw={(val) => setFctwVal(val)}
          addToCart={handleAddToCart}
          removeFromCart={handleRemoveFromCart}
          emptyCart={setCartItems}
          onChangeStatus={(val) => setStatusVal(val)}
          setRegionValue={(val) => setRegion(val)}
        />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <ExecutionListingOfOpenLoop
          type={type}
          isReportingMode={true}
          selectValue={modelVal}
        />
      </TabPanel>
    </div>
  );
}
export default OpenLooReportingMode;
